<div class="filters" id="prenote-history-filters-container">
  <ssg-side-filter (apply)="applyEdits()" (reset)="clearEditFilters()" (toggle)="toggleFilters($event)" [isDisabled]="!editFilters" [isInvalid]="!editFilters || isWorking" class="flex-column">
    <div *ngIf="editFilters" class="flex-fill flex-column">
      <div class="wrap-container vertical-spacing fontstyling flex-fill flex-row flex-gap-5pct">
        <div class="flex-100">
          <div class="text-muted" data-automation="company_name_edit_label" translate>COMPANIES.FILTER_COMPANY_LABEL</div>
          <ssg-multi-select [items]="companiesDataSource" bindLabel="legalName" [multiple]="true" placeholder="{{ 'COMPANIES.SEARCH' | translate }}" [(ngModel)]="editFilters.companies" (search)="searchCompaniesByLegalName($event)" data-automation="company_name_select">
          </ssg-multi-select>
        </div>
      </div>
    </div>
  </ssg-side-filter>
</div>
